import { ClockIcon, XMarkIcon } from "@heroicons/react/24/outline";
import {
  useGetActiveBanner,
  useDismissBanner,
} from "@via/api/system-banner.api.tsx";
import { type JSX } from "react";

export default function SystemBanner(): JSX.Element | null {
  const { data: activeBanner, isLoading } = useGetActiveBanner();
  const { dismissBanner } = useDismissBanner();

  // Don't render anything while loading or if there's no active banner
  if (isLoading || !activeBanner) {
    return null;
  }

  const handleDismiss = () => {
    if (activeBanner.id && activeBanner.updatedAt) {
      dismissBanner(activeBanner.id, activeBanner.updatedAt);
    }
  };

  return (
    <div className="flex items-center gap-x-2 rounded-md bg-amber-50 border border-amber-200 px-3 py-1.5">
      <ClockIcon
        className="h-4 w-4 text-amber-600 flex-shrink-0"
        aria-hidden="true"
      />
      <div className="flex flex-col text-left">
        <p
          className="text-xs font-semibold text-amber-800 leading-tight whitespace-nowrap"
          title={activeBanner.primaryMessage}>
          {activeBanner.primaryMessage}
        </p>
        {activeBanner.secondaryMessage && (
          <p
            className="text-xs text-amber-700 leading-tight whitespace-nowrap"
            title={activeBanner.secondaryMessage}>
            {activeBanner.secondaryMessage}
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="flex-shrink-0 rounded p-0.5 text-amber-600 hover:bg-amber-100 hover:text-amber-800 focus:outline-none">
        <span className="sr-only">Dismiss</span>
        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
